import {
  FETCH_RAW_STOCKS_REQUEST,
  FETCH_RAW_STOCKS_SUCCESS,
  FETCH_RAW_STOCKS_FAILURE,
  CREATE_RAW_STOCK,
  UPDATE_RAW_STOCK,
  DELETE_RAW_STOCK,
  FETCH_RAW_STOCK_REPORT_REQUEST,
  FETCH_RAW_STOCK_REPORT_SUCCESS,
  FETCH_RAW_STOCK_REPORT_FAILURE
} from '../../types/rawStock/rawStockTypes';
import { 
  fetchRawStocks as fetchRawStocksApi, 
  fetchRawStockReport as fetchRawStockReportApi, 
  createRawStock as createRawStockApi, 
  updateRawStock as updateRawStockApi, 
  deleteRawStock as deleteRawStockApi 
} from '../../../api/rawStock/rawStockApi';

export const getRawStocks = (params = {}, options = {}) => async (dispatch) => {
  const append = Boolean(options.append);
  dispatch({ type: FETCH_RAW_STOCKS_REQUEST, append });
  try {
    const { data } = await fetchRawStocksApi(params);
    dispatch({ type: FETCH_RAW_STOCKS_SUCCESS, payload: data, append });
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch raw stocks';
    dispatch({ type: FETCH_RAW_STOCKS_FAILURE, payload: errorMessage, append });
    throw error;
  }
};

// Export the old function name for backward compatibility
export const fetchRawStocks = getRawStocks;

export const getRawStockReport = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_RAW_STOCK_REPORT_REQUEST });
  try {
    const { data } = await fetchRawStockReportApi(params);
    dispatch({ type: FETCH_RAW_STOCK_REPORT_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch raw stock report';
    dispatch({ type: FETCH_RAW_STOCK_REPORT_FAILURE, payload: errorMessage });
  }
};

// Export the old function name for backward compatibility
export const fetchRawStockReport = getRawStockReport;

export const createRawStockAction = (data) => async (dispatch) => {
  try {
    const response = await createRawStockApi(data);
    dispatch({ type: CREATE_RAW_STOCK, payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to create raw stock';
    throw new Error(errorMessage);
  }
};

// Export the old function name for backward compatibility
export const createRawStock = createRawStockAction;

export const updateRawStockAction = (id, data) => async (dispatch) => {
  try {
    await updateRawStockApi(id, data);
    dispatch({ type: UPDATE_RAW_STOCK, payload: { id, data } });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to update raw stock';
    throw new Error(errorMessage);
  }
};

// Export the old function name for backward compatibility
export const updateRawStock = updateRawStockAction;

export const deleteRawStockAction = (id) => async (dispatch) => {
  try {
    await deleteRawStockApi(id);
    dispatch({ type: DELETE_RAW_STOCK, payload: id });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete raw stock';
    throw new Error(errorMessage);
  }
};

// Export the old function name for backward compatibility
export const deleteRawStock = deleteRawStockAction; 